export const STORAGE_SESSION_KEY = 'has_session';
